export default __webpack_public_path__ + "static/media/courses-illustration.56276deb.svg";